import React from 'react'
import { Link } from 'react-router-dom'

export default () => {
	return (
		<Link className="sign-out-button" to="/">Sign Out</Link>
	)
}



// WEBPACK FOOTER //
// ./src/desktop/components/sign-out-button/index.js